import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrackRow } from "@/components/TrackRow";
import type { Track } from "@/stores/player";
import { Clock } from "lucide-react";

export const Route = createFileRoute("/_authed/history")({
  head: () => ({ meta: [{ title: "History — Sura" }] }),
  component: HistoryPage,
});

function HistoryPage() {
  const [tracks, setTracks] = useState<Track[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/history?page=1&limit=20").then(({ data }) => {
      const items = data.history || data.items || data || [];
      setTracks(items.map((x: any) => x.track || x).filter(Boolean));
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-4 md:px-8 py-6 md:py-10 max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <Clock className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Recently Played</h1>
          <p className="text-sm text-muted-foreground">Your listening history</p>
        </div>
      </div>

      {loading ? (
        <div className="text-center text-muted-foreground py-12">Loading…</div>
      ) : tracks.length === 0 ? (
        <div className="text-center text-muted-foreground py-20">No play history yet.</div>
      ) : (
        <div className="bg-card border border-border rounded-2xl p-2">
          {tracks.map((t, i) => <TrackRow key={`${t.id}-${i}`} track={t} index={i} queue={tracks} />)}
        </div>
      )}
    </div>
  );
}
